import { alpha, createTheme, outlinedInputClasses } from '@mui/material';
import breakpoints from 'config/theme/breakpoints';
import palette from 'config/theme/palette';
import typography from 'config/theme/typography';

const theme = createTheme({
  breakpoints,
  palette,
  typography,
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          padding: '8px 16px',
          [breakpoints.up('sm')]: {
            padding: '8px 16px',
          },
          [breakpoints.up('md')]: {
            padding: '8px 16px',
          },
          [breakpoints.up('lg')]: {
            padding: '8px 16px',
          },
          [breakpoints.up('xl')]: {
            padding: '8px 16px',
          },
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
        square: true,
      },
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
        },
      },
    },
    MuiBadge: {
      defaultProps: {
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
        max: Number.MAX_SAFE_INTEGER,
      },
      styleOverrides: {
        badge: {
          minWidth: 32,
          height: 32,
          left: 20,
          top: 20,
          borderRadius: 16,
          border: '4px solid white',
          fontSize: 15,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            [`& .${outlinedInputClasses.notchedOutline}`]: {
              borderColor: palette.text.disabled,
            },
          },
        },
        notchedOutline: {
          borderColor: palette.primary.main,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { minWidth: 48 },
        containedError: {
          '&.Mui-disabled': {
            backgroundColor: alpha(palette.error.main, 0.7),
            color: alpha(palette.text.primary, 0.7),
          },
        },
        containedPrimary: {
          '&.Mui-disabled': {
            backgroundColor: alpha(palette.primary.dark, 0.8),
            color: alpha(palette.text.primary, 0.7),
          },
        },
      },
    },
  },
});

export default theme;
